import { extractSummary, type ArticleDetailDto } from '@zoxo/shared';

/**
 * Short Korean date for article cards/detail (YYYY.MM.DD), **KST 기준**.
 *
 * 실행 환경의 시간대를 쓰지 않는다 — 서버와 브라우저의 시간대가 다르면 서버 HTML 과
 * hydration 첫 렌더의 날짜가 달라진다. `daysUntilDeadline` 과 같은 방식이다.
 */
export function formatDate(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  return new Date(t + 9 * 3_600_000).toISOString().slice(0, 10).replace(/-/g, '.');
}

/** Summary text for OG/meta description of an article page. */
export function articleSummary(article: ArticleDetailDto): string {
  return article.summary || extractSummary(article.body) || article.title;
}
